import React from "react";
import { UserProvider } from "./context/UserContext";
import AppRouter from "./router";
import "antd/dist/reset.css";
import { NotificationProvider } from "./context/NotificationContext";
import { CommonProvider } from "./context/CommonContext";

import { ConfigProvider } from "antd";
 
// Spacing only — no colours. The palette stays exactly as antd renders it
// today; these tokens just give the sidebar items room to breathe and inset
// them from the rail edge so they read as a list rather than stacked bars.
const customTheme = {
  components: {
    Menu: {
      itemBorderRadius: 8,
      itemMarginInline: 8,
      itemHeight: 44,
      itemMarginBlock: 4,
    },
  },
};

function App() {
  return (
    <CommonProvider>
      <NotificationProvider>
        <ConfigProvider theme={customTheme}>
          <UserProvider>
            <div className="overflow-hidden">
              <AppRouter />
            </div>
          </UserProvider>
        </ConfigProvider>
      </NotificationProvider>
    </CommonProvider>
  );
}

export default App;
